import { grey } from "@mui/material/colors";

const styles = {
  logo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "12px 12px 0px",
    width: 48,
    height: 48,
    background: "linear-gradient(135deg, #B1B3F8 0%, #7C86FF 100%)",
    borderRadius: "10px",
  },
  card: (completed?: boolean) => ({
    px: 3,
    py: 2,
    maxWidth: "1000px",
    background: completed ? "#F0FDF4" : "white",
    border: "2px solid",
    borderColor: completed ? "#B9F8CF" : "#E5E7EB",
    borderRadius: "10px",
  }),
  infoBox: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    px: 3,
    py: 2,
    gap: 2,
    width: "100%",
    background: "rgba(247, 238, 111, 0.3)",
    border: "1px solid rgba(247, 238, 111, 0.5)",
    borderRadius: "10px",
    mb: "16px",
  },
  infoBoxIcon: {
    width: "16px",
    height: "16px",
    mt: 1,
  },
  logoContainer: (completed?: boolean) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 12px",
    width: 48,
    height: 48,
    background: completed ? "#00C950" : "rgba(177, 179, 248, 0.2)",
    borderRadius: "50%",
    flexShrink: 0,
  }),
  chip: (completed?: boolean) => ({
    my: { xs: 1, md: 0 },
    backgroundColor: completed ? "primary.main" : "yellow.main",
    borderRadius: 4,
    fontWeight: 600,
    fontSize: "0.7rem",
    color: completed ? "#FFFFFF" : "#92400E",
  }),
  text: {
    color: "#4A5565",
    whiteSpace: "nowrap",
  },
  pitchText: {
    fontWeight: 600,
    color: "#4F39F6",
    whiteSpace: "nowrap",
  },
  weekBox: {
    flex: { xs: "0 0 calc(50% - 6px)", md: "0 0 calc(25% - 6px)" },
    height: "64px",
    backgroundColor: "#F3F4F6",
    border: "2px solid #D1D5DC",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    minWidth: 0,
  },
  weekText: {
    fontSize: "12px",
    lineHeight: "16px",
    color: "#4A5565",
    whiteSpace: "nowrap",
  },
  weekProgressText: {
    color: "primary.main",
    fontWeight: 600,
  },
  earnCreditChip: {
    my: { xs: 1, md: 0 },
    background: "linear-gradient(90deg, #014339 0%, #009966 100%)",
    borderRadius: "9999px",
    fontWeight: 600,
    fontSize: "0.7rem",
    color: "#FFFFFF",
    width: "142.79px",
    height: "24px",
    "& .MuiChip-label": { px: "10px" },
  },
  linearProgress: {
    height: "10px",
    borderRadius: "9999px",
    backgroundColor: grey[200],
  },
  dollarIcon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 12px",
    width: 48,
    height: 48,
    background: "linear-gradient(135deg, #014339 0%, #009966 100%)",
    borderRadius: "50%",
    flexShrink: 0,
  },
  earnedCreditCompleted: {
    /* Container */
    background: "linear-gradient(90deg, #00C950 0%, #009966 100%)",
    borderRadius: 3,
    p: 3,
    color: "white",
  },
  nextActionBox: {
    border: "1px solid #E5E7EB",
    mt: 2,
    backgroundColor: "#F9FAFB",
    borderRadius: 3,
    px: { xs: 1, md: 3 },
    py: 2,
  },
};

export default styles;
